import React from 'react'
import { v4 as uuid } from 'uuid'
import { useNavigate } from 'react-router-dom'
import { ErrorView } from '../ErrorView'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { IllustrationChoices } from '../../../components/common/Illustration'
import { useWindowDimensions } from '../../../hooks/useWindowDimensions'
import { useIsMobile } from '../../../hooks/useIsMobile'
import { ButtonVariant } from '../../../components/common/Button'
import { Container } from '../../../components/common/Container'

export const NotFoundView = (): JSX.Element => {
  const { translate } = useAppTranslation()
  const { height } = useWindowDimensions()
  const isMobile = useIsMobile()
  const navigate = useNavigate()

  return (
    <Container className="flex h-full items-center justify-center">
      <ErrorView
        title={translate('notFoundView.title')}
        subtitle={translate('notFoundView.subtitle')}
        titleWrapperClassName="mt-8 md:mt-16"
        illustration={IllustrationChoices.EMPTY}
        illustrationHeight={isMobile ? height * 0.35 : height * 0.25}
        buttons={[
          {
            id: uuid(),
            button: {
              label: translate('notFoundView.buttonLabel'),
              onClick: () => navigate(-1),
              variant: ButtonVariant.PRIMARY,
            },
          },
        ]}
      />
    </Container>
  )
}
